/* eslint-disable */
import React, { useState, useContext } from 'react';
import { useTheme } from '@emotion/react';
import PropTypes from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import { ThemeContext } from '../../theme';

const propTypes = {};
const defaultProps = {};

const NumberInput = props => {
  const { value, arrowDirection, unit, unitDirection, decimalRounding, width } = props;

  const theme = useTheme();
  const context = useContext(ThemeContext);

  const [numValue, setNumValue] = useState(value);

  let numberInput;
  if (theme && theme.numberInput) {
    numberInput = theme.numberInput;
  } else {
    numberInput = context.theme.numberInput;
  }

  // Helper function
  const roundedNumValue = value.toFixed(decimalRounding);

  // Handler functions
  // const handleOnChangeValue = () => { };

  const styles = StyleSheet.create({
    containerStyle: {
      display: 'flex',
      tabIndex: '0',
      width: `${width}px`,
      height: '40px',
      border: `1px solid ${numberInput.props.borderColor}`,
      ':focus': {
        border: `1px solid ${numberInput.focusedProps.focusedBorderColor}`
      },
      ':focus-within': {
        border: `1px solid ${numberInput.focusedProps.focusedBorderColor}`
      }
    }, 
    numInput: {
      outline: 'none',
      border: '0',
      background: numberInput.props.background,
      color: numberInput.props.color,
      caretColor: numberInput.props.caretColor,
      // width: `${arrowDirection === 'vertical' ? width - 26 + 'px' : width - 50 + 'px'}`,
      width: `${props.width}px`,
      height: '38px',
      textAlign: 'center',
      fontSize: '12px'
    },
    btnStyles: {
      background: numberInput.buttonProps.background,
      color: numberInput.buttonProps.color,
      width: '24px',
      height: '30px',
      fontSize: '24px',
      padding: '0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: '0'
    }
  });

  return (
    <div className={css(styles.containerStyle)}>
      {/* Left - button */}
      {arrowDirection === 'horizontal' ?
        <button
          className={css(styles.btnStyles)}
          onClick={props.handleOnDecrementClick}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="8"
            height="5"
          >
            <path
              d="M4 5L0 0h8z"
              fill={numberInput.buttonProps.color}
              fillRule="evenodd"
            />
          </svg>
        </button> : null
      }
      {/* Input */}
      <input
        type="text"
        value={`${unitDirection === 'prefix' ? unit + roundedNumValue : roundedNumValue + unit}`}
        onChange={props.handleOnChangeValue}
        className={css(styles.numInput)}
      />

      {/* Right + button */}
      {arrowDirection === 'horizontal' ?
        <button
          onClick={props.handleOnIncrementClick}
          className={css(styles.btnStyles)}
        >
          <svg
            width="8"
            height="5"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4 0l4 5H0z"
              fill={numberInput.buttonProps.color}
              fillRule="evenodd"
            />
          </svg>
        </button> : (
          <div
            style={{
              display: 'flex',
              flexFlow: 'column'
            }}
          >
            {/* Up Arrow button */}
            <button
              onClick={props.handleOnIncrementClick}
              className={css(styles.btnStyles)}
              style={{
                height: '14.5px',
                marginBottom: '1px',
              }}
            >
              <svg
                width="8"
                height="5"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4 0l4 5H0z"
                  fill={numberInput.buttonProps.color}
                  fillRule="evenodd"
                />
              </svg>
            </button>

            {/* Down Arrow button */}
            <button
              onClick={props.handleOnDecrementClick}
              className={css(styles.btnStyles)}
              style={{
                height: '14.5px'
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="8"
                height="5"
              >
                <path
                  d="M4 5L0 0h8z"
                  fill={numberInput.buttonProps.color}
                  fillRule="evenodd"
                />
              </svg>
            </button>

          </div>
        )
      }
    </div>
  );
}

NumberInput.propTypes = propTypes;
NumberInput.defaultProps = defaultProps;

export { NumberInput };
